// The maximum number of Group nodes to render in the group list initially
export const MAX_GROUP_NODES_WHEN_COLLAPSED = 5;

// The maximum number of messages that can be dropped into a group node
export const MAX_NUM_MESSAGES_DROPPED_IN_GROUP = 100;
